module.exports = __webpack_public_path__ + "img/33.0d558134.svg";